import { render, staticRenderFns } from "./InviteCollaboratorModal.vue?vue&type=template&id=72c1f93f&"
import script from "./InviteCollaboratorModal.vue?vue&type=script&lang=js&"
export * from "./InviteCollaboratorModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports